import React, { useState } from 'react';
import {
  Popover, Checkbox, FormControlLabel, Button, Typography, IconButton,
  Box,
  Divider,
} from '@mui/material';
import { weekdays } from 'src/utils';
import { Copy } from 'react-feather';

const CopyToDays = ({
  day, watch, append, small, name
}: {
  day: string;
  watch: (day: string) => any;
  append: (value: any) => void;
  name: string;
  small?: boolean;
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDays, setSelectedDays] = useState<string[]>([]);
  const slots = watch(name);

  const slotsForDay = slots?.filter((slot) => slot.day === day.toUpperCase());

  const handleToggleDay = (targetDay: string) => {
    if (selectedDays.includes(targetDay)) {
      setSelectedDays((prev) => prev.filter((d) => d !== targetDay));
    } else {
      setSelectedDays((prev) => [...prev, targetDay]);
    }
  };

  const handleApply = () => {
    const slotsToCopy = slotsForDay?.flatMap((slot) => selectedDays.map((day) => ({
      day: day.toUpperCase(),
      startTime: slot.startTime,
      endTime: slot.endTime,
    })));
    append(slotsToCopy);
    setAnchorEl(null);
    setSelectedDays([]);
  };

  return (
    <>
      <IconButton size={small ? 'small' : undefined} onClick={(e) => setAnchorEl(e.currentTarget)}>
        <Copy size={small ? '16px' : '18px'} color="#475467" />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <Box paddingX={2} paddingY={1}>
          <Typography variant="h6" pb="5px">Copy times to</Typography>
          {weekdays
            .filter((weekday) => weekday !== day)
            .map((weekday) => (
              <Box>
                <FormControlLabel
                  key={weekday}
                  control={(
                    <Checkbox
                      size="small"
                      style={{ paddingTop: 0, paddingBottom: 0, color: '#D0D5DD' }}
                      checked={selectedDays.includes(weekday)}
                      onChange={() => handleToggleDay(weekday)}
                    />
                  )}
                  label={weekday.charAt(0).toUpperCase() + weekday.slice(1)}
                />
              </Box>
            ))}
        </Box>
        <Divider />
        <Box padding={1} display="flex" justifyContent="space-between">
          <Button onClick={() => { setAnchorEl(undefined); setSelectedDays([]) }} variant="outlined" color="primary" size="small">
            Cancel
          </Button>
          <Button onClick={handleApply} variant="contained" color="primary" size="small" disabled={!selectedDays?.length}>
            Apply
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default CopyToDays;
